import { useEffect, useRef, useState } from 'react';
// src/pages/AgreementPage.jsx
import { useLocation, useNavigate } from "react-router-dom";
import apiService from '../services/apiService';

    import { COMPANY } from "../constants/company";

const InfoNote = ({ children }) => (
  <div className="rounded-lg bg-blue-50 text-blue-800 px-4 py-3 text-sm ring-1 ring-blue-100">
    {children}
  </div>
);

const H = ({ children, className = "" }) => (
  <h3 className={`mt-6 text-base font-semibold text-gray-900 ${className}`}>
    {children}
  </h3>
);

export default function AgreementPage() {




//   const canvasRef = useRef(null);
//   const isDrawing = useRef(false);
//   const [signature, setSignature] = useState(null);
  



// const getPos = (e, canvas) => {
//   const rect = canvas.getBoundingClientRect();
//   if (e.touches) {
//     return {
//       x: e.touches[0].clientX - rect.left,
//       y: e.touches[0].clientY - rect.top,
//     };
//   }
//   return {
//     x: e.clientX - rect.left,
//     y: e.clientY - rect.top,
//   };
// };

// const startDrawing = (e) => {
//   const canvas = canvasRef.current;
//   const ctx = canvas.getContext("2d");
//   const { x, y } = getPos(e, canvas);

//   ctx.beginPath();
//   ctx.moveTo(x, y);
//   ctx.strokeStyle = "#065f46";
//   ctx.lineWidth = 2;
//   ctx.lineCap = "round";

//   isDrawing.current = true;
// };

// const draw = (e) => {
//   if (!isDrawing.current) return;

//   const canvas = canvasRef.current;
//   const ctx = canvas.getContext("2d");
//   const { x, y } = getPos(e, canvas);

//   ctx.lineTo(x, y);
//   ctx.stroke();
// };

// const stopDrawing = () => {
//   isDrawing.current = false;
// };

// const clearSignature = () => {
//   const canvas = canvasRef.current;
//   const ctx = canvas.getContext("2d");
//   ctx.clearRect(0, 0, canvas.width, canvas.height);
//   setSignature(null);
// };

// const saveSignature = () => {
//   const canvas = canvasRef.current;
//   setSignature(canvas.toDataURL("image/png"));
// };





  const canvasRef = useRef(null);
  const isDrawing = useRef(false);
  const [signature, setSignature] = useState(null);

  // 🔥 Setup canvas for mobile & retina screens
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const ratio = window.devicePixelRatio || 1;
    const cssWidth = canvas.offsetWidth;
    const cssHeight = 180;

    canvas.width = cssWidth * ratio;
    canvas.height = cssHeight * ratio;

    canvas.style.height = `${cssHeight}px`;

    ctx.scale(ratio, ratio);
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
  }, []);

  // 📍 Get correct mouse/touch position
  const getPos = (e, canvas) => {
    const rect = canvas.getBoundingClientRect();

    if (e.touches && e.touches.length > 0) {
      return {
        x: e.touches[0].clientX - rect.left,
        y: e.touches[0].clientY - rect.top,
      };
    }

    return {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };
  };

  // ✍️ Start drawing
  const startDrawing = (e) => {
    e.preventDefault();

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const { x, y } = getPos(e, canvas);

    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.strokeStyle = "#065f46";
    ctx.lineWidth = window.innerWidth < 768 ? 3 : 2;

    isDrawing.current = true;
  };

  // 🖊 Draw
  const draw = (e) => {
    if (!isDrawing.current) return;
    e.preventDefault();

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const { x, y } = getPos(e, canvas);

    ctx.lineTo(x, y);
    ctx.stroke();
  };

  // ✋ Stop drawing
  const stopDrawing = () => {
    isDrawing.current = false;
  };

  // 🧹 Clear signature
  const clearSignature = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    setSignature(null);
  };

  // 💾 Save signature
  const saveSignature = () => {
    const canvas = canvasRef.current;
    setSignature(canvas.toDataURL("image/png"));
  };



   const navigate = useNavigate();
  const location = useLocation();

   // ✅ Extract query params from URL
  const searchParams = new URLSearchParams(location.search);
  const queryName = searchParams.get("name") || "";
  const queryEmail = searchParams.get("email") || "";
  const queryMobile = searchParams.get("mobile") || "";

  // Form state
  const [fullName, setFullName] = useState(queryName);
  const [email, setEmail] = useState(queryEmail);
  const [mobile, setMobile] = useState(queryMobile);
  const [accepted, setAccepted] = useState(true); // default checked like your screenshot

  // --- Email OTP state ---
  const [otpSent, setOtpSent] = useState(false);
  const [otpCountdown, setOtpCountdown] = useState(0);
  const [otp, setOtp] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const [sending, setSending] = useState(false);
  const [verifying, setVerifying] = useState(false);
   const [loading, setLoading] = useState(false);

  // Cooldown timer
  useEffect(() => {
    if (!otpSent || otpCountdown <= 0) return;
    const t = setInterval(
      () => setOtpCountdown((s) => Math.max(0, s - 1)),
      1000
    );
    return () => clearInterval(t);
  }, [otpSent, otpCountdown]);




    // ✅ Send OTP
  const handleSendOtp = async () => {
    if (!email) return alert("Please enter your email first.");
    try {
      setSending(true);
      const res = await apiService.sendOtp(email);
      if (res.ok) {
        setOtpSent(true);
        setOtpCountdown(30);
        setOtp("");
        alert("✅ OTP sent successfully!");
      } else {
        alert(res.message || "Failed to send OTP.");
      }
    } catch (err) {
      console.error(err);
      alert("❌ Server error while sending OTP.");
    } finally {
      setSending(false);
    }
  };

  // ✅ Verify OTP
  const handleVerifyOtp = async () => {
    if (otp.length !== 6) return alert("Please enter a 6-digit OTP.");
    try {
      setVerifying(true);
      const res = await apiService.verifyOtp(email, otp);
      if (res.ok) {
        setOtpVerified(true);
        alert("✅ Email verified successfully!");
      } else {
        alert("❌ Invalid or expired OTP.");
      }
    } catch (err) {
      console.error(err);
      alert("❌ Failed to verify OTP.");
    } finally {
      setVerifying(false);
    }
  };

  // ✅ Submit Agreement (send agreement email)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!accepted) return alert("You must accept the Terms & Conditions first.");
    if (!otpVerified) return alert("Please verify your email first.");

    try {
      setLoading(true);
      const res = await apiService.sendAgreement(email ,signature);
      if (res.ok) {
        alert("✅ Agreement PDF sent successfully to your email!");
        navigate("/thank-you", { state: { fullName, email, mobile } });
      } else {
        alert("❌ Failed to send agreement email.");
      }
    } catch (err) {
      console.error(err);
      alert("❌ Server error while sending agreement email.");
    } finally {
      setLoading(false);
    }
  };

  const canSubmit = accepted && otpVerified;

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="mx-auto w-full sm:max-w-3xl">
        <div className="rounded-3xl border border-gray-200 bg-white p-6 sm:p-8 shadow-sm">
          {/* Header */}
          <div className="text-center">
            <h1 className="text-3xl font-extrabold tracking-tight text-gray-900">
              User Agreement
            </h1>
            <p className="mt-2 text-sm text-gray-600">
              Review your details and accept Terms & Conditions.
            </p>
          </div>

      
   






          <div className="-mx-4 sm:mx-0">
  <div className="prose max-w-none prose-sm text-gray-800 leading-6 px-4 sm:px-0">

    <p className="font-medium">
      Parties to these Terms and Conditions:
    </p>

    <p>
      <strong>i. Research Analyst:</strong> Deepti Sarkar, a SEBI Registered
      Research Analyst, holding Registration No. INH000017408, with its
      registered office located at Navi Mumbai near Juinagar Railway Station,
      hereinafter referred to as the &quot;Research Analyst&quot; or &quot;RA&quot;.
    </p>

    <p>
      <strong>ii. Client:</strong> The individual or entity subscribing to or
      availing research services provided by the Research Analyst, hereinafter
      referred to as the &quot;Client&quot;.
    </p>

    <H>1. Availing The Services:</H>
    <p>
      The Client hereby accepts the research services and confirms to avail the
      research services on its own discretion provided by the Research Analyst
      (&quot;RA&quot;), and the Research Analyst agrees to provide such services
      in accordance with the terms and conditions set forth underneath.
    </p>

    <H>2. Obligations on RA and Client:</H>
    <p>
      The Client and the Research Analyst shall be bound by all applicable
      regulations, rules, circulars, and amendments issued by SEBI, including
      the SEBI (Research Analysts) Regulations, 2014 and all the other
      notifications of the Government, if any from time to time.
    </p>

    <H>3. Client Information and KYC:</H>
    <p>
      The Client is bound, upon acceptance of services, to submit all requisite
      documents as requested by the Research Analyst and help the RA to
      complete the KYC process.
    </p>

    <InfoNote>
      “The client hereby gives consent to the research analyst to fetch his KYC
      documents from the KYC Registration Agency (KRA).”
    </InfoNote>

    <H>4. Standard Terms of Service:</H>
    <p>
      The Client acknowledges and gives his consent to be bound by the terms set
      forth herewith, as well as any applicable amendments or updates provided
      by the Research Analyst.
    </p>

    <p className="font-medium">The client hereby agrees:</p>
    <ol className="list-decimal pl-5">
      <li>
        I have read and understood the terms and conditions applicable to a
        research analyst as defined under regulation 2(1)(u) of the SEBI
        (Research Analyst) Regulations, 2014, including the fee structure.
      </li>
      <li>
        I am subscribing to the research services for my own benefit and
        consumption, and any reliance placed on the research report provided by
        the Research Analyst shall be based on my own judgment and assessment.
      </li>
      <li>
        All communication shall be conducted via WhatsApp. It shall be the sole
        responsibility of the client to review and verify all information
        provided.
      </li>
    </ol>

    <p className="mt-4 font-medium">I understand that:</p>
    <ul className="list-disc pl-5">
      <li>
        Any investment made based on the recommendations in the research report
        is subject to market risk.
      </li>
      <li>
        Recommendations in the research report do not provide any assurance of
        returns.
      </li>
      <li>
        There is no recourse to claim any losses incurred on investments made
        based on the recommendations in the research report.
      </li>
    </ul>

    <H>Declaration by Research Analyst:</H>
    <ol className="list-decimal pl-5">
      <li>
        It is duly registered with SEBI as an RA having Registration No.:
        INH000017408.
      </li>
      <li>
        It has registration and qualifications required to render the services
        contemplated under the RA Regulations, and the same are valid and
        subsisting.
      </li>
      <li>
        The services provided by the RA do not conflict with or violate any
        provision of law, rule, regulation, contract, or other instrument.
      </li>
      <li>
        The maximum fee that may be charged by the RA is ₹1.51 lakhs per annum
        per family of clients.
      </li>
      <li>
        The recommendations provided by the RA do not provide any assurance of
        returns.
      </li>
      <li>
        The RA is not engaged in any additional professional or business
        activities on a full-time or executive capacity that may interfere with
        or influence the independence of the research report.
      </li>
    </ol>

    <H>5. Consideration And Mode of Payment:</H>
    <ol className="list-decimal pl-5">
      <li>
        The Client shall duly pay the fees to the RA of the invoice raised or any
        agreed amount within 2 days.
      </li>
      <li>
        Payments shall be made only via UPI, Net Banking, Payment Gateway or
        other verified banking channels. Cash payment is not allowed.
      </li>
      <li>
        Payments must be made only to the bank account of the Research Analyst.
        The RA shall not be liable for any payment made to a third-party account.
      </li>
    </ol>



    <H>6. Risk Factors:</H>
<p>
  The Client understands that the services provided by the Research Analyst
  involve inherent risks, and the Client agrees to bear full responsibility
  for any financial or other consequences arising from the use of these
  services.
</p>

<p>
  Investment in the market is subject to market risk, and is also subject to
  the following:
</p>

<ul className="list-disc pl-5">
  <li>
    Trading in equities, derivatives, and other securities are subject to
    market risks and there is no assurance or guarantee of returns.
  </li>
  <li>
    Past performance does not indicate future performance.
  </li>
  <li>
    Research recommendations may not always be profitable, as actual market
    movements may differ from anticipated trends.
  </li>
  <li>
    The Research Analyst is not responsible or liable for any losses resulting
    from research recommendations.
  </li>
  <li>
    Investment in securities market are subject to market risks. Read all the
    related documents carefully before investing.
  </li>
  <li>
    Registration granted by SEBI, membership of BASL, and certification from
    NISM do not guarantees the performance of the intermediary or provide any
    assurance of returns to investors.
  </li>
</ul>


<H>7. Conflict of Interest:</H>
<p>
  The Research Analyst shall adhere to the applicable
  regulations/circulars/directions specified by SEBI from time to time
  in relation to disclosure and mitigation of any actual or potential
  conflict of interest. Some of disclosures are as follows:
</p>

<ul className="list-disc pl-5">
  <li>
    The Research Analyst or any of its officer/employee does not trade
    in securities which are subject matter of recommendation.
  </li>
  <li>
    There are no actual or potential conflicts of interest arising from
    any connection to or association with any issuer of products/
    securities, including any material information or facts that might
    compromise its objectivity or independence in the carrying on of
    Research Analyst services. Such conflict of interest shall be
    disclosed to the client as and when they arise.
  </li>
  <li>
    Research Analyst or its employee or its associates have not received
    any compensation from the company which is subject matter of
    recommendation.
  </li>
</ul>

<p>
  Client is advised to refer the detailed disclosure provided on our
  website.
</p>


<H>8. Termination of Service and Refund of Fees:</H>
<p>
  The Agreement may be terminated by the client, if the Research Analyst
  fails to provide the research recommendations. However, the client
  cannot terminate the agreement solely based on not achieving the
  desired returns or incurring the losses from trading on the
  recommendations or if the client discontinues the services without a
  valid reason, or in case of force majeure.
</p>

<p>
  The Research Analyst may suspend or terminate rendering of research
  services to the client on account of suspension or cancellation of
  registration of the Research Analyst by SEBI and shall refund the
  residual amount to the client.
</p>

<p>
  In case of suspension of certificate of registration of the Research
  Analyst for more than 60 (sixty) days or cancellation of the Research
  Analyst registration, the Research Analyst shall refund the fees on a
  pro rata basis for the period from the effective date of
  cancellation/suspension to the end of the subscription period.
</p>

<H>9. Grievance Redressal:</H>
<p>
  In the event of grievances related to non-receipt of the research
  report, missing content, or deficiencies in services, the Client may
  raise a grievance. The Research Analyst will ensure redressal within
  7 days of such complaint.
</p>

<p className="font-medium">
  The client is required to follow the following procedure for any
  grievance:
</p>

<ol className="list-decimal pl-5">
  <li>
    <strong>Step 1:</strong> The client should first contact the Research
    Analyst at the contact details mentioned below:
    <br />
    <strong>Mail ID:</strong> deeptisarkar7@gmail.com
  </li>
  <li>
    <strong>Step 2:</strong> In case the client is unsatisfied, he/she
    can lodge a complaint with SEBI through SEBI’s SCORES platform at{" "}
    <a
      href="https://www.scores.sebi.gov.in"
      target="_blank"
      rel="noopener noreferrer"
    >
      www.scores.sebi.gov.in
    </a>
    .
  </li>
  <li>
    <strong>Step 3:</strong> The client may also consider seeking
    resolution through the Online Dispute Resolution (ODR) mechanism
    via SMART ODR Portal at{" "}
    <a
      href="https://smartodr.in"
      target="_blank"
      rel="noopener noreferrer"
    >
      https://smartodr.in
    </a>
    .
  </li>
</ol>

<p className="mt-2 text-gray-700">
  <strong>DISCLAIMER:</strong> The client is strictly required to follow
  the procedure as mentioned above, otherwise the Research Analyst shall
  not be liable for delay in resolution of the grievance.
</p>

<p className="text-gray-700">
  <strong>NOTE:</strong> Clients are advised to read the Do&apos;s and
  Don&apos;ts for dealing with the Research Analyst, as mentioned in SEBI
  Master Circular No. SEBI/HO/MIRSD-POD-1/P/CIR/2024/49 dated May 21, 2024,
  or any updates provided by SEBI in the future. Clients are also
  requested to go through all the Disclaimers, Disclosures, Refund
  Policy, and information as mentioned on the website.
</p>


<H>10. Most Important Terms and Conditions:</H>

<ol className="list-decimal pl-5">
  <li>
    These terms and conditions, and consent thereon are for the research
    services provided by the Research Analyst (RA) and the RA cannot
    execute or carry out any trade (purchase/sell transaction) on behalf
    of the client. Clients are advised not to permit the RA to execute any
    trade on their behalf.
  </li>

  <li>
    The fee charged by the RA to the client shall be subject to the
    maximum amount prescribed by SEBI / Research Analyst Administration
    and Supervisory Body (RAASB) from time to time (applicable only for
    Individual and HUF clients).
    <p className="mt-2 font-medium">Note:</p>
    <ul className="list-disc pl-5">
      <li>
        The current fee limit is Rs. 1,51,000/- per annum per family of
        client for all research services of the RA.
      </li>
      <li>The fee limit does not include statutory charges.</li>
      <li>
        The fee limits do not apply to a non-individual client /
        accredited investor.
      </li>
    </ul>
  </li>

  <li>
    The RA may charge fees in advance if agreed by the client. Such
    advance shall not exceed the period stipulated by SEBI; presently it
    is one year. In case of pre-mature termination of RA services by
    either party, the client shall be entitled to a refund of
    proportionate fees only for the unexpired period.
  </li>

  <li>
    Fees may be paid by the client through cheque, online bank transfer,
    UPI, etc. Cash payment is not allowed. Optionally, the client may
    make payments through the Centralized Fee Collection Mechanism
    (CeFCoM) managed by BSE Limited.
  </li>

  <li>
    The RA shall abide by applicable regulations, circulars, and
    directions issued by SEBI and RAASB in relation to disclosure and
    mitigation of conflicts of interest and shall promptly inform the
    client of any conflict affecting the services.
  </li>

  <li>
    Any assured, guaranteed, or fixed return schemes are prohibited by
    law. No such scheme shall be offered by the RA.
  </li>

  <li>
    The RA cannot guarantee returns, profits, accuracy, or risk-free
    investments. All opinions and projections are based on analysis of
    available data and assumptions as on the date of preparation of the
    research report.
  </li>

  <li>
    Investments made based on research recommendations are subject to
    market risks and do not assure returns. There is no recourse to claim
    losses. Any reliance placed on the research report shall be as per
    the client’s own judgement.
  </li>

  <li>
    SEBI registration, enlistment with RAASB, and NISM certification do
    not guarantee the performance of the RA or assure returns.
  </li>

  <li>
    <strong>For any grievances:</strong>
    <p className="mt-2 font-medium">Step 1: Contact the Research Analyst</p>

    <div className="overflow-x-auto">
      <table className="table-auto border border-gray-300 text-sm mt-2">
        <thead className="bg-gray-100">
          <tr>
            <th className="border px-2 py-1">Designation</th>
            <th className="border px-2 py-1">Contact Person</th>
            <th className="border px-2 py-1">Office Address</th>
            <th className="border px-2 py-1">Contact No.</th>
            <th className="border px-2 py-1">Email ID</th>
            <th className="border px-2 py-1">Working Hours</th>
          </tr>
        </thead>
        <tbody>
          {[
            "Customer Care",
            "Head of Customer Care",
            "Compliance Officer",
            "CEO",
            "Principal Officer",
          ].map((role) => (
            <tr key={role}>
              <td className="border px-2 py-1">{role}</td>
              <td className="border px-2 py-1">Deepti Sarkar</td>
              <td className="border px-2 py-1">_________</td>
              <td className="border px-2 py-1">919082280240</td>
              <td className="border px-2 py-1">
                deeptisarkar7@gmail.com
              </td>
              <td className="border px-2 py-1">
                Mon–Fri, 10:00 AM – 6:00 PM
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    <p className="mt-3">
      <strong>Step 2:</strong> If the resolution is unsatisfactory, the
      client may lodge grievances through SEBI’s SCORES platform at{" "}
      <a
        href="https://www.scores.sebi.gov.in"
        target="_blank"
        rel="noopener noreferrer"
      >
        www.scores.sebi.gov.in
      </a>
      .
    </p>

    <p>
      <strong>Step 3:</strong> The client may also consider Online Dispute
      Resolution (ODR) through the Smart ODR portal at{" "}
      <a
        href="https://smartodr.in"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://smartodr.in
      </a>
      .
    </p>
  </li>
</ol>


    <H>11. Optional Centralised Fee Collection Mechanism:</H>
    <p>
    There is an optional ‘Centralized Fee Collection Mechanism for Investment Advisors and Research Analysts’ (CeFCoM) for fee payments. The Research Analyst has presently not opted for the same and once the Research Analyst gets registered for it, then thereafter said mechanism will be available for the client.
    </p>

    <H>12. Confidentiality:</H>
    <p>
    Client shall not share any confidential information with third party without prior consent from the RA which has come to its knowledge.
    </p>

    <H>13. Dispute:</H>
    <p>
    No suit, prosecution or other legal proceeding shall lie against the Research Analyst for any damage caused or likely to be caused by anything which is done in good faith or intended to be done under the provisions of the Securities and Exchange Board of India (Research Analyst) Regulations, 2014.
    <br/>
Any Disputes between the parties shall be resolved through arbitration or other methods mutually agreed upon, in accordance with applicable legal and regulatory guidelines.

    </p>

    <H>14. Severability:</H>
    <p>
    If any provision of this Terms and Conditions is found to be invalid, illegal, or unenforceable, the remaining provisions will remain in full effect, provided the essential purpose of the Terms and Conditions is not undermined.
    </p>

    <H>15. Force majeure:</H>
    <p>
    Neither party shall be held liable for failure or delay in performance under this Terms and Conditions due to circumstances beyond their reasonable control, including but not limited to natural disasters, government actions, or other unforeseen events.
    </p>

    <InfoNote>
      The client agrees to abide by the terms and conditions of the research
      services.
    </InfoNote>

  </div>
</div>






          {/* Confirmation/Footer form */}
          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Full Name *
              </label>
              <input
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
                className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 outline-none ring-emerald-200 focus:ring-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Email *
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 outline-none ring-emerald-200 focus:ring-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Mobile Number *
              </label>
              <input
                type="tel"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                pattern="[6-9][0-9]{9}"
                inputMode="numeric"
                required
                className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 outline-none ring-emerald-200 focus:ring-2"
              />
            </div>

          

            <div className="mt-4">
  <label className="block text-sm font-medium text-gray-700">
    Email Verification <span className="text-red-500">*</span>
  </label>

  {/* OTP Input */}
  <input
    type="text"
    placeholder="Enter 6-digit code"
    inputMode="numeric"
    value={otp}
    onChange={(e) =>
      setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))
    }
    className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 outline-none ring-emerald-200 focus:ring-2"
  />

  {/* Helper Text */}
  <p className="mt-2 text-xs leading-relaxed text-gray-500">
    To verify your email address, we&apos;ll send you a 6-digit verification code.
  </p>

  {/* Buttons */}
  <div className="mt-3 flex flex-col gap-2 sm:flex-row sm:gap-3">
    <button
      type="button"
      onClick={handleSendOtp}
      disabled={sending || otpCountdown > 0}
      className={`h-10 w-full sm:w-auto rounded-lg px-4 text-sm font-semibold ${
        sending || otpCountdown > 0
          ? "bg-gray-100 text-gray-400 border border-gray-200 cursor-not-allowed"
          : "bg-blue-100 text-blue-700 border border-blue-200 hover:bg-blue-200"
      }`}
    >
      {otpCountdown > 0
        ? `Resend in ${otpCountdown}s`
        : sending
        ? "Sending..."
        : "Send OTP"}
    </button>

    <button
      type="button"
      onClick={handleVerifyOtp}
      disabled={verifying || !otp || otp.length !== 6 || otpVerified}
      className={`h-10 w-full sm:w-auto rounded-lg px-4 text-sm font-semibold ${
        otpVerified
          ? "bg-emerald-100 text-emerald-700 border border-emerald-200 cursor-default"
          : "bg-emerald-600 text-white hover:bg-emerald-700"
      }`}
    >
      {otpVerified
        ? "Verified"
        : verifying
        ? "Verifying..."
        : "Verify"}
    </button>
  </div>
</div>


            <p className="mt-2 rounded-lg bg-blue-50 text-blue-800 px-4 py-3 text-sm ring-1 ring-blue-100">
              Click “Send OTP” above to receive your verification code.
            </p>










            {/* E-Signature */}
<div className="mt-6">
  <label className="block text-sm font-medium text-gray-700">
    E-Signature <span className="text-red-500">*</span>
  </label>





{/* 
  <div className="mt-2 rounded-lg border border-gray-300 bg-white p-2">
    <canvas
      ref={canvasRef}
      width={600}
      height={280}
      className="w-full cursor-crosshair touch-none"
      onMouseDown={startDrawing}
      onMouseMove={draw}
      onMouseUp={stopDrawing}
      onMouseLeave={stopDrawing}
      onTouchStart={startDrawing}
      onTouchMove={draw}
      onTouchEnd={stopDrawing}
    />
  </div> */}




  <div className="mt-2 rounded-xl border border-gray-300 bg-white p-2">
        <canvas
          ref={canvasRef}
          className="w-full touch-none cursor-crosshair rounded-md"
          onMouseDown={startDrawing}
          onMouseMove={draw}
          onMouseUp={stopDrawing}
          onMouseLeave={stopDrawing}
          onTouchStart={startDrawing}
          onTouchMove={draw}
          onTouchEnd={stopDrawing}
        />
      </div>

  <div className="mt-3 flex gap-3">
    <button
      type="button"
      onClick={saveSignature}
      className="rounded-lg bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700"
    >
      Save Signature
    </button>

    <button
      type="button"
      onClick={clearSignature}
      className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-600 hover:bg-gray-100"
    >
      Clear
    </button>
  </div>

  {!signature && (
    <p className="mt-2 text-xs text-gray-500">
      Please draw your signature above using mouse or touch.
    </p>
  )}

  {signature && (
    <p className="mt-2 text-xs font-medium text-emerald-600">
      ✔ Signature saved successfully
    </p>
  )}
</div>




















            <label className="mt-2 flex items-center gap-2 text-sm">
              <input
                type="checkbox"
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
                className="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-500"
              />
              <span>
                I accept the{" "}
                <span className="font-medium">Terms & Conditions</span> of {COMPANY.NAME}.
              </span>
            </label>




















             {/* Submit Button with Loader */}
  <button
    type="submit"
    disabled={!canSubmit || loading}
    className={`w-full rounded-lg px-5 py-3 text-white shadow flex items-center justify-center ${
      !canSubmit || loading
        ? "bg-emerald-300 cursor-not-allowed"
        : "bg-emerald-600 hover:bg-emerald-700 focus:outline-none focus:ring-4 focus:ring-emerald-300"
    }`}
  >
    {loading ? (
      <>
        <svg
          className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          ></path>
        </svg>
        Processing...
      </>
    ) : (
      "Accept Terms & Receive PDF"
    )}
  </button>
          </form>
       
       
        </div>
      </div>
    </div>
  );
}
